import Checkbox from '@components/Checkbox';
import CheckboxLI from '@components/CheckboxLI';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useAgreement from './hooks/useAgreement';

function Agreements() {
    const { t } = useTranslation('signUp');
    const {
        isAllChecked, agreeAll,
        termCategories, toggleTermCategory, isChecked,
    } = useAgreement();
    const { push } = useFlow();
    return (
        <Container as='section' spacing={2} fullWidth >
            <Text size='title' fontWeight='bold'>
                {t('agreements.title')}
            </Text>
            <Column fullWidth>
                <All>
                    <Checkbox isChecked={isAllChecked}
                        onClick={agreeAll} >
                        {t('agreements.agreeAll')}
                    </Checkbox>
                </All>
                {termCategories.map((termCategory) => (
                    <CheckboxLI isChecked={isChecked(termCategory.id)}
                        key={termCategory.id}
                        required={termCategory.isRequired}
                        onClick={() => push('TermDetailActivity', { termCategoryId: termCategory.id })}
                        toggleCheckbox={() => toggleTermCategory(termCategory.id)}>
                        {termCategory.title}
                    </CheckboxLI>
                ))}
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

const All = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

export default Agreements;
